import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { BLACK, LIGHT_BLACK } from "../../utils/colors";
import { useStyles } from "./styles";
import { CircularProgress } from "@mui/material";
import { Countdown } from "../../components/Countdown";
import Stack from "@mui/system/Stack";
interface HeaderProps {
  title?: string;
  subTitle?: string;
  showButtonUpdate?: boolean;
  buttonClick?: () => void;
  isLoading?: boolean;
}

const TIME_BUTTON = 300;

export function Header(props: HeaderProps) {
  const { title, subTitle, showButtonUpdate, buttonClick, isLoading } = props;
  const [disableUpdate, setDisableUpdate] = useState(false);

  const styles = useStyles();
  return (
    <Box className={styles.root} gap="4px">
      <Stack spacing={2} direction="row" alignItems="center">
        <Typography fontWeight={500} lineHeight="26px" color={BLACK}>
          {title || "Métricas mensais"}
        </Typography>
        {showButtonUpdate ? (
          <Button
            size="small"
            data-testid="btn-update-insights"
            variant="contained"
            onClick={() => {
              if (buttonClick) {
                buttonClick();
                setDisableUpdate(true);
              }
            }}
            disabled={disableUpdate}
          >
            {!disableUpdate ? (
              "Atualizar"
            ) : (
              <Countdown
                triggersOnZero={() => {
                  setDisableUpdate(false);
                }}
                initialCount={TIME_BUTTON}
              />
            )}
          </Button>
        ) : isLoading ? (
          <CircularProgress variant="indeterminate" sx={{ mt: 2 }} />
        ) : (
          <></>
        )}
      </Stack>
      <Typography
        variant="body2"
        fontWeight={500}
        lineHeight="22px"
        color={LIGHT_BLACK}
      >
        {subTitle || "Veja e compare os resultados de um mês para o outro."}
      </Typography>
    </Box>
  );
}
